<mat-toolbar *ngIf="customFooter">
    <div id="customFooter">
        <ul>
            <li *ngFor="let custom of customLinks">
                <a [href]="[custom.url]" target="_blank">{{custom.text}}</a>
            </li>
        </ul>
    </div>
</mat-toolbar>